import { render, staticRenderFns } from "./ComponentDist.vue?vue&type=template&id=3a0faaef"
import script from "./ComponentDist.vue?vue&type=script&lang=js"
export * from "./ComponentDist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports